export default __webpack_public_path__ + "static/media/events_page_default_image.7489ef72.jpeg";